import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

// Set initial password link url from email will look like this: /set-initial-password/totp?token=<token>&user_id=<user_id>&token_type=<token_type>
export const getSetInitialPasswordValidateTotpPath = () => urlHelper(`/set-initial-password/totp`);
